import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { FlatProtocol } from '../mutations/useUploadProtocol'

export const flatProtocolsQueryKey = ['flat-protocols']

export function useFlatProtocols(flatId: string | undefined) {
  async function getProtocols() {
    const response = await apiClient.get<FlatProtocol[]>(
      `${SNA_PREFIX}flats/${flatId}/protocols`
    )

    return response.data
  }

  return useQuery({
    queryFn: getProtocols,
    enabled: !!flatId,
    queryKey: [...flatProtocolsQueryKey, flatId]
  })
}
